var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c("div"),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.modalFilterDateFrom = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "statistics.dateFrom"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateFrom = null
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .dateFromFormatted,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "dateFromFormatted",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.dateFromFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterDateFrom = $$v
                                    },
                                    expression: "modalFilterDateFrom"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateFrom = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateFrom,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateFrom", $$v)
                                        },
                                        expression: "filter.dateFrom"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateFrom = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.modalFilterDateTo = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "statistics.dateTo"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateTo = null
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter.dateToFormatted,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "dateToFormatted",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.dateToFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateTo,
                                    callback: function($$v) {
                                      _vm.modalFilterDateTo = $$v
                                    },
                                    expression: "modalFilterDateTo"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateTo = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateTo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateTo", $$v)
                                        },
                                        expression: "filter.dateTo"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateTo = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.groupByItemsValues,
                                  label: _vm.$t("statistics.groupBy")
                                },
                                model: {
                                  value: _vm.filter.groupBy,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "groupBy", $$v)
                                  },
                                  expression: "filter.groupBy"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.search()
                      }
                    }
                  }),
                  _vm.searched
                    ? _c("crud-button", {
                        attrs: {
                          large: "",
                          color: "green",
                          icon: "fa-file-export",
                          tooltip: _vm.$t("global.crud.buttons.export")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.doExport()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _vm.searched
              ? _c("line-chart", {
                  attrs: { chartdata: _vm.chartData, options: _vm.chartOptions }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }